<template>
    <div data-elementor-type="wp-post" data-elementor-id="6" class="elementor elementor-6" data-elementor-settings="[]">
      <div class="elementor-inner">
        <div class="elementor-section-wrap">
          <div
            class="elementor-section elementor-top-section elementor-element elementor-element-52c240b overflow-hidden elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="52c240b" data-element_type="section">
            <div class="elementor-container elementor-column-gap-default">
              <div class="elementor-row">
                <div
                  class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-144daf9"
                  data-id="144daf9" data-element_type="column">
                  <div class="elementor-column-wrap elementor-element-populated">
                    <div class="elementor-widget-wrap">
                      <div
                        class="elementor-element elementor-element-278a4d5 elementor-widget elementor-widget-wp-widget-rev-slider-widget"
                        data-id="278a4d5" data-element_type="widget"
                        data-widget_type="wp-widget-rev-slider-widget.default">
                        <div class="elementor-widget-container">

                          <!-- START Home 01 REVOLUTION SLIDER 6.3.5 --><p class="rs-p-wp-fix"></p>
                          <rs-module-wrap id="rev_slider_6_1_wrapper" data-source="gallery"
                                          style="background:transparent;padding:0;margin: 0 auto;">
                            <rs-module id="rev_slider_6_1" style="" data-version="6.3.5">
                              <rs-slides>
                                <rs-slide data-key="rs-9" data-title="Intro"
                                          data-anim="ei:d;eo:d;s:1800;r:0;t:fade;sl:d;">
                                  <img
                                    src="../assets/images/transparent.png"
                                    alt="Intro" title="Home One"
                                    data-bg="c:linear-gradient(-45deg, rgba(16,69,219,1) 0%, rgba(21,9,94,1) 60%);"
                                    data-parallax="5" class="rev-slidebg" data-no-retina>

                                  <rs-layer
                                    id="slider-6-slide-9-layer-1"
                                    data-type="image"
                                    data-rsp_ch="on"
                                    data-xy="x:r,r,c,c;xo:-25px,1px,256px,0;y:m,m,m,t;yo:34px,-80px,-6px,504px;"
                                    data-text="l:22;"
                                    data-dim="w:661px,661,550px,350px;h:554px,554,461px,293px;"
                                    data-frame_1="st:360;sR:360;"
                                    data-frame_999="st:w;sR:8340;"
                                    style="z-index:5;"
                                  ><img
                                        src="../assets/images/banner_image.png"
                                        width="661" height="554" data-no-retina>
                                  </rs-layer>
                                  <rs-layer
                                    id="slider-6-slide-9-layer-7"
                                    data-type="text"
                                    data-rsp_ch="on"
                                    data-xy="xo:137px,148px,57px,40px;y:m,m,m,t;yo:-138px,-137px,-184px,214px;"
                                    data-text="s:24,24,23,14;l:29,29,28,17;ls:0px,0,0px,0px;fw:400,400,300,400;"
                                    data-frame_0="x:-50px;"
                                    data-frame_1="e:power2.out;st:1000;sp:1000;sR:1000;"
                                    data-frame_999="o:0;e:power4.in;st:w;sp:1510;sR:7000;"
                                    style="z-index:6;font-family:Rubik;"
                                  >WE PROVIDE
                                  </rs-layer>
                                  <a
                                    id="slider-6-slide-9-layer-8"
                                    class="rs-layer btn btn-primary rev-btn"
                                    href="https://dash.episcloud.vn/login" target="_self"
                                    data-type="button"
                                    data-color="rgba(255, 255, 255, 1)"
                                    data-xy="xo:137px,148px,57px,40px;y:m,m,m,t;yo:90px,90px,128px,383px;"
                                    data-text="s:17,16,16,15;l:25,48,48,38;ls:1px;fw:400,400,400,700;a:center,left,left,left;"
                                    data-rsp_bd="off"
                                    data-padding="t:14,0,0,0;r:45,40,40,24;b:14,0,0,0;l:45,40,40,24;"
                                    data-border="boc:#1868dd;bow:2,2,2,2;bor:50px,50px,50px,50px;"
                                    data-frame_0="x:-50px;"
                                    data-frame_1="e:power2.out;st:1750;sp:1000;sR:1750;"
                                    data-frame_999="o:0;e:power4.in;st:w;sp:1510;sR:6250;"
                                    style="z-index:8;background-color:#1868dd;font-family:Karla,serif;border:1px solid rgb(24, 104, 221);"
                                  >Get Started
                                  </a>
                                  <rs-layer
                                    id="slider-6-slide-9-layer-9"
                                    data-type="text"
                                    data-rsp_ch="on"
                                    data-xy="xo:137px,148px,57px,40px;y:m,m,m,t;yo:2px,-4px,36px,286px;"
                                    data-text="w:normal;s:17,16,16,17;l:24,24,24,27;ls:0px,0,0,0;"
                                    data-dim="w:600px,356px,334px,450px;h:auto,auto,76px,auto;"
                                    data-frame_0="x:-50px;"
                                    data-frame_1="e:power2.out;st:1500;sp:1000;sR:1500;"
                                    data-frame_999="o:0;e:power4.in;st:w;sp:1510;sR:6500;"
                                    style="z-index:7;font-family:Karla,serif;"
                                  >Share processes and data securely on a need to know basis without the need for
                                    reconciliation it combines a permissione.
                                  </rs-layer>
                                  <rs-layer
                                    id="slider-6-slide-9-layer-16"
                                    data-type="text"
                                    data-rsp_ch="on"
                                    data-xy="xo:137px,148px,57px,40px;y:m,m,m,t;yo:-76px,-76px,-85px,246px;"
                                    data-text="w:nowrap,nowrap,normal,nowrap;s:64,64,64,17;l:76,76,65,20;ls:0px,0,0px,0px;fw:700;"
                                    data-dim="w:auto,auto,308px,auto;"
                                    data-frame_0="x:-50px;"
                                    data-frame_1="e:power2.out;st:1000;sp:1000;sR:1000;"
                                    data-frame_999="o:0;e:power4.in;st:w;sp:1510;sR:7000;"
                                    style="z-index:9;font-family:Rubik;"
                                  >PREMIUM HOSTING
                                  </rs-layer>
                                  <rs-layer
                                    id="slider-6-slide-9-layer-19"
                                    class="banner-ico banner-ico-1"
                                    data-type="image"
                                    data-rsp_ch="on"
                                    data-xy="xo:915px,631px,496px,147px;yo:168px,37px,259px,509px;"
                                    data-text="l:22;a:inherit;"
                                    data-dim="w:45px,57px,35px,25px;h:64px,81px,50px,36px;"
                                    data-wrpcls="hosting-info-img"
                                    data-frame_1="st:360;sR:360;"
                                    data-frame_999="o:0;st:w;sR:8340;"
                                    data-loop_999="sp:4000;yym:t;yys:t;yyf:t;"
                                    style="z-index:10;"
                                  ><img
                                        src="../assets/images/banner_icon_1.png"
                                        width="40" height="57" data-no-retina>
                                  </rs-layer>
                                  <rs-layer
                                    id="slider-6-slide-9-layer-20"
                                    class="banner-ico banner-ico-2"
                                    data-type="image"
                                    data-rsp_ch="on"
                                    data-xy="xo:1144px,836px,682px,265px;yo:140px,6px,231px,495px;"
                                    data-text="l:22;a:inherit;"
                                    data-dim="w:45px,57px,35px,25px;h:63px,81px,49px,35px;"
                                    data-wrpcls="hosting-info-img"
                                    data-frame_0="rZ:2;"
                                    data-frame_1="rZ:2;st:360;sR:360;"
                                    data-frame_999="o:0;st:w;sR:8340;"
                                    style="z-index:11;"
                                  ><img
                                        src="../assets/images/banner_icon_2.png"
                                        width="41" height="57" data-no-retina>
                                  </rs-layer>
                                  <rs-layer
                                    id="slider-6-slide-9-layer-21"
                                    class="banner-ico banner-ico-3"
                                    data-type="image"
                                    data-rsp_ch="on"
                                    data-xy="xo:965px,691px,539px,175px;yo:371px,226px,431px,615px;"
                                    data-text="l:22;a:inherit;"
                                    data-dim="w:45px,57px,35px,25px;h:62px,81px,48px,34px;"
                                    data-wrpcls="hosting-info-img"
                                    data-frame_1="st:360;sR:360;"
                                    data-frame_999="o:0;st:w;sR:8340;"
                                    style="z-index:12;"
                                  ><img
                                        src="../assets/images/banner_icon_3.png"
                                        width="41" height="57" data-no-retina>
                                  </rs-layer>
                                  <rs-layer
                                    id="slider-6-slide-9-layer-22"
                                    class="banner-ico banner-ico-4"
                                    data-type="image"
                                    data-rsp_ch="on"
                                    data-xy="xo:1192px,889px,725px,290px;yo:361px,221px,435px,617px;"
                                    data-text="l:22;a:inherit;"
                                    data-dim="w:45px,57px,35px,25px;h:64px,81px,50px,36px;"
                                    data-wrpcls="hosting-info-img"
                                    data-frame_1="st:360;sR:360;"
                                    data-frame_999="o:0;st:w;sR:8340;"
                                    style="z-index:13;"
                                  ><img
                                        src="../assets/images/banner_icon_4.png"
                                        width="38" height="54" data-no-retina>
                                  </rs-layer>
                                  <rs-layer
                                    id="slider-6-slide-9-layer-23"
                                    class="btn btn-outline-primary rev-btn"
                                    data-type="button"
                                    data-color="rgba(255, 255, 255, 1)"
                                    data-xy="xo:360px,360px,270px,255px;y:m,m,m,t;yo:89px,90px,128px,383px;"
                                    data-text="s:17,16,16,15;l:25,48,48,38;ls:1px;fw:400,400,400,700;a:center,left,left,left;"
                                    data-actions='o:click;a:scrollbelow;sp:300;e:none;'
                                    data-rsp_bd="off"
                                    data-padding="t:14,0,0,0;r:45,40,40,24;b:14,0,0,0;l:45,40,40,35;"
                                    data-border="bos:solid;boc:#ffffff;bow:1px,1px,1px,1px;bor:50px,50px,50px,50px;"
                                    data-frame_0="x:-50px;"
                                    data-frame_1="e:power2.out;st:1750;sp:1000;sR:1750;"
                                    data-frame_999="o:0;e:power4.in;st:w;sp:1510;sR:6250;"
                                    data-frame_hover="bgc:transparent;boc:rgba(24,104,221,0.8);bor:50px,50px,50px,50px;bos:solid;bow:1px,1px,1px,1px;oX:50;oY:50;e:none;"
                                    style="z-index:14;background-color:rgba(24,104,221,0);font-family:Karla;"
                                  >Know More
                                  </rs-layer>
                                </rs-slide>
                              </rs-slides>
                              <rs-static-layers>
                                <rs-layer
                                  id="slider-6-slide-6-layer-1"
                                  class="- rs-layer-static"
                                  data-type="text"
                                  data-color="rgba(255,255,255,1)"
                                  data-xy="x:r;xo:30px;yo:30px;"
                                  data-text="l:22;"
                                  data-actions='o:click;a:toggleclass;layer:slider-6-slide-6-layer-1;d:0;class:open;||o:click;a:togglelayer;ls:hidden;layer:slider-6-slide-6-layer-3;d:0;||o:click;a:togglelayer;ls:hidden;layer:slider-6-slide-6-layer-4;d:0;||o:click;a:togglelayer;ls:hidden;layer:slider-6-slide-6-layer-5;d:0;||o:click;a:togglelayer;ls:hidden;layer:slider-6-slide-6-layer-6;d:0;'
                                  data-basealign="slide"
                                  data-rsp_o="off"
                                  data-rsp_bd="off"
                                  data-onslides="s:-1;e:-1;"
                                  data-frame_0="tp:600;"
                                  data-frame_1="tp:600;st:500;sp:1000;"
                                  data-frame_999="st:w;sp:1000;auto:true;"
                                  style="z-index:5;"
                                >
                                  <div id="rev-burger">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                  </div>
                                </rs-layer>
                              </rs-static-layers>
                            </rs-module>
                          </rs-module-wrap>
                          <!-- END REVOLUTION SLIDER -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-section elementor-top-section elementor-element elementor-element-8a12f2b elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default"
            data-id="8a12f2b" data-element_type="section"
            data-settings="{&quot;stretch_section&quot;:&quot;section-stretched&quot;}">
            <div class="elementor-container elementor-column-gap-narrow">
              <div class="elementor-row">
                <div
                  class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-f6fc0e9"
                  data-id="f6fc0e9" data-element_type="column">
                  <div class="elementor-column-wrap">
                    <div class="elementor-widget-wrap">
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-f6bf32f domain-search"
                  data-id="f6bf32f" data-element_type="column"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
<!--                  <div class="elementor-column-wrap elementor-element-populated">-->
<!--&lt;!&ndash;                    <div class="elementor-widget-wrap">&ndash;&gt;-->
<!--&lt;!&ndash;                      <div&ndash;&gt;-->
<!--&lt;!&ndash;                        class="elementor-element elementor-element-f8c698d elementor-widget elementor-widget-xs-domain-checker"&ndash;&gt;-->
<!--&lt;!&ndash;                        data-id="f8c698d" data-element_type="widget" data-widget_type="xs-domain-checker.default">&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="elementor-widget-container">&ndash;&gt;-->
<!--&lt;!&ndash;                          <div id="wdc-domain-form" class="wdc-form " data-wdc-style="1">&ndash;&gt;-->
<!--&lt;!&ndash;                            <div id="wdc-style">&ndash;&gt;-->
<!--&lt;!&ndash;                              <form method="post" action="" id="form" class="pure-form" data-wdc-style="1">&ndash;&gt;-->

<!--&lt;!&ndash;                                <input type="hidden" name="integration" value="whmcs_bridge">&ndash;&gt;-->
<!--&lt;!&ndash;                                <input type="hidden" name="available_msg" value="{domain} is available">&ndash;&gt;-->
<!--&lt;!&ndash;                                <input type="hidden" name="unavailable_msg" value="{domain} is unavailable">&ndash;&gt;-->
<!--&lt;!&ndash;                                <input type="hidden" name="item_id" value="https://episcloud.com/whmcs-bridge/">&ndash;&gt;-->
<!--&lt;!&ndash;                                <input type="hidden" name="url" value="">&ndash;&gt;-->
<!--&lt;!&ndash;                                <input type="hidden" name="allowed_tld" value="">&ndash;&gt;-->
<!--&lt;!&ndash;                                <input type="hidden" name="tld" value="">&ndash;&gt;-->
<!--&lt;!&ndash;                                <input type="hidden" name="whois_button" value="disable">&ndash;&gt;-->
<!--&lt;!&ndash;                                <input type="hidden" name="custom_price" value="">&ndash;&gt;-->
<!--&lt;!&ndash;                                <div class="input-group large" style="max-width:900px;">&ndash;&gt;-->
<!--&lt;!&ndash;                                  <input type="text" class="form-control" autocomplete="off" id="Search" name="domain"&ndash;&gt;-->
<!--&lt;!&ndash;                                         placeholder="domain.com">&ndash;&gt;-->
<!--&lt;!&ndash;                                  <span class="input-group-btn">&ndash;&gt;-->
<!--&lt;!&ndash;                        <button type="submit" id="Submit" class="btn btn-default btn-info">Search</button>&ndash;&gt;-->
<!--&lt;!&ndash;                        </span>&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->

<!--&lt;!&ndash;                                <div id="loading"><img&ndash;&gt;-->
<!--&lt;!&ndash;                                  src="../assets/images/load.gif"&ndash;&gt;-->
<!--&lt;!&ndash;                                  alt="loading"/></div>&ndash;&gt;-->
<!--&lt;!&ndash;                              </form>&ndash;&gt;-->
<!--&lt;!&ndash;                              <div style="max-width:900px;">&ndash;&gt;-->
<!--&lt;!&ndash;                                <div id="results" class="result large">&ndash;&gt;-->
<!--&lt;!&ndash;                                  <div class="callout callout-warning alert-warning clearfix req-domain-text">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <div class="col-xs-10" style="padding-left:1px;text-align:left;"><i&ndash;&gt;-->
<!--&lt;!&ndash;                                      class="glyphicon glyphicon-remove" style="margin-right:10px;"></i> Please enter&ndash;&gt;-->
<!--&lt;!&ndash;                                      your&ndash;&gt;-->
<!--&lt;!&ndash;                                      domain.&ndash;&gt;-->
<!--&lt;!&ndash;                                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                  <div class="callout callout-warning alert-warning clearfix recaptcha-text">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <div class="col-xs-10" style="padding-left:1px;text-align:left;"><i&ndash;&gt;-->
<!--&lt;!&ndash;                                      class="glyphicon glyphicon-remove" style="margin-right:10px;"></i> Please verify&ndash;&gt;-->
<!--&lt;!&ndash;                                      that you are not a robot.&ndash;&gt;-->
<!--&lt;!&ndash;                                    </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->

<!--&lt;!&ndash;                              </div>&ndash;&gt;-->
<!--&lt;!&ndash;                            </div>&ndash;&gt;-->
<!--&lt;!&ndash;                          </div>&ndash;&gt;-->
<!--&lt;!&ndash;                          <ul class="xs-domain-info">&ndash;&gt;-->
<!--&lt;!&ndash;                            <li>&ndash;&gt;-->
<!--&lt;!&ndash;                              <img src="../assets/images/com.png" alt="com"&ndash;&gt;-->
<!--&lt;!&ndash;                                   draggable="false">&ndash;&gt;-->
<!--&lt;!&ndash;                              <strong>$9.95</strong>&ndash;&gt;-->
<!--&lt;!&ndash;                            </li>&ndash;&gt;-->

<!--&lt;!&ndash;                            <li>&ndash;&gt;-->
<!--&lt;!&ndash;                              <img src="../assets/images/co.png" alt="co"&ndash;&gt;-->
<!--&lt;!&ndash;                                   draggable="false">&ndash;&gt;-->
<!--&lt;!&ndash;                              <strong>$7.95</strong>&ndash;&gt;-->
<!--&lt;!&ndash;                            </li>&ndash;&gt;-->

<!--&lt;!&ndash;                            <li>&ndash;&gt;-->
<!--&lt;!&ndash;                              <img src="../assets/images/info.png" alt="info"&ndash;&gt;-->
<!--&lt;!&ndash;                                   draggable="false">&ndash;&gt;-->
<!--&lt;!&ndash;                              <strong>$2.95</strong>&ndash;&gt;-->
<!--&lt;!&ndash;                            </li>&ndash;&gt;-->

<!--&lt;!&ndash;                            <li>&ndash;&gt;-->
<!--&lt;!&ndash;                              <img src="../assets/images/net.png" alt="net"&ndash;&gt;-->
<!--&lt;!&ndash;                                   draggable="false">&ndash;&gt;-->
<!--&lt;!&ndash;                              <strong>$5.95</strong>&ndash;&gt;-->
<!--&lt;!&ndash;                            </li>&ndash;&gt;-->

<!--&lt;!&ndash;                            <li>&ndash;&gt;-->
<!--&lt;!&ndash;                              <img src="../assets/images/store.png" alt="store"&ndash;&gt;-->
<!--&lt;!&ndash;                                   draggable="false">&ndash;&gt;-->
<!--&lt;!&ndash;                              <strong>$2.95</strong>&ndash;&gt;-->
<!--&lt;!&ndash;                            </li>&ndash;&gt;-->

<!--&lt;!&ndash;                          </ul>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                      </div>&ndash;&gt;-->
<!--&lt;!&ndash;                    </div>&ndash;&gt;-->
<!--                  </div>-->
                </div>
                <div
                  class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-e8cd132"
                  data-id="e8cd132" data-element_type="column">
                  <div class="elementor-column-wrap">
                    <div class="elementor-widget-wrap">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-section elementor-top-section elementor-element elementor-element-2690de2 overflow-hidden elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="2690de2" data-element_type="section">
            <div class="elementor-container elementor-column-gap-default">
              <div class="elementor-row">
                <div
                  class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-772b5ef"
                  data-id="772b5ef" data-element_type="column">
                  <div class="elementor-column-wrap">
                    <div class="elementor-widget-wrap">
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-60f310d"
                  data-id="60f310d" data-element_type="column">
                  <div class="elementor-column-wrap elementor-element-populated">
                    <div class="elementor-widget-wrap">
                      <div
                        class="elementor-element elementor-element-7d8b806 elementor-widget elementor-widget-xs-heading"
                        data-id="7d8b806" data-element_type="widget" data-widget_type="xs-heading.default">
                        <div class="elementor-widget-container">
                          <div class="xs-heading" style="margin-top: 75px">
                            <h3 class="heading-sub-title">Best Hosting</h3>
                            <h2 class="heading-title">WHY <span>CHOOSE US</span></h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-585abc9"
                  data-id="585abc9" data-element_type="column">
                  <div class="elementor-column-wrap">
                    <div class="elementor-widget-wrap">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-section elementor-top-section elementor-element elementor-element-d186241 overflow-hidden elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="d186241" data-element_type="section">
            <div class="elementor-container elementor-column-gap-default">
              <div class="elementor-row">
                <div
                  class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-af7e844 animated-slow elementor-invisible"
                  data-id="af7e844" data-element_type="column"
                  data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:0.7}">
                  <div class="elementor-column-wrap elementor-element-populated">
                    <div class="elementor-widget-wrap">
                      <div
                        class="elementor-element elementor-element-d8c0e9d elementor-widget elementor-widget-xs-image-box"
                        data-id="d8c0e9d" data-element_type="widget" data-widget_type="xs-image-box.default">
                        <div class="elementor-widget-container">
                          <div class="why-choose-us-block">
                            <div class="choose-us-img">
                              <img width="254" height="190"
                                   src="../assets/images/choose-us-1.png"
                                   class="attachment-full size-full" alt="" /></div>
                            <h4 class="xs-title">99.9% Uptime Guarantee</h4>
                            <p>Share processes and data secure
                              lona need to know basis</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-82eda63 animated-slow elementor-invisible"
                  data-id="82eda63" data-element_type="column"
                  data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:1.5}">
                  <div class="elementor-column-wrap elementor-element-populated">
                    <div class="elementor-widget-wrap">
                      <div
                        class="elementor-element elementor-element-6d96648 elementor-widget elementor-widget-xs-image-box"
                        data-id="6d96648" data-element_type="widget" data-widget_type="xs-image-box.default">
                        <div class="elementor-widget-container">
                          <div class="why-choose-us-block">
                            <div class="choose-us-img">
                              <img width="254" height="190"
                                   src="../assets/images/choose-us-2.png"
                                   class="attachment-full size-full" alt="" /></div>
                            <h4 class="xs-title">Safe and Secured</h4>
                            <p>Our team assured your web site is always safe and secure</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-923a80d animated-slow elementor-invisible"
                  data-id="923a80d" data-element_type="column"
                  data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:2}">
                  <div class="elementor-column-wrap elementor-element-populated">
                    <div class="elementor-widget-wrap">
                      <div
                        class="elementor-element elementor-element-889caab elementor-widget elementor-widget-xs-image-box"
                        data-id="889caab" data-element_type="widget" data-widget_type="xs-image-box.default">
                        <div class="elementor-widget-container">
                          <div class="why-choose-us-block">
                            <div class="choose-us-img">
                              <img width="254" height="190"
                                   src="../assets/images/choose-us-3.png"
                                   class="attachment-full size-full" alt="" /></div>
                            <h4 class="xs-title">Our Dedicated Support</h4>
                            <p>We finally found a host that truly understood the unique</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
<!--          <div-->
<!--            class="elementor-section elementor-top-section elementor-element elementor-element-3a4ff38 elementor-section-boxed elementor-section-height-default elementor-section-height-default"-->
<!--            data-id="3a4ff38" data-element_type="section"-->
<!--            data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">-->
<!--            <div class="elementor-container elementor-column-gap-default">-->
<!--              <div class="elementor-row">-->
<!--                <div-->
<!--                  class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-882917f"-->
<!--                  data-id="882917f" data-element_type="column">-->
<!--                  <div class="elementor-column-wrap elementor-element-populated">-->
<!--                    <div class="elementor-widget-wrap">-->
<!--                      <div-->
<!--                        class="elementor-section elementor-inner-section elementor-element elementor-element-45afde6 elementor-section-boxed elementor-section-height-default elementor-section-height-default"-->
<!--                        data-id="45afde6" data-element_type="section">-->
<!--                        <div class="elementor-container elementor-column-gap-default">-->
<!--                          <div class="elementor-row">-->
<!--                            <div-->
<!--                              class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-7f24746"-->
<!--                              data-id="7f24746" data-element_type="column">-->
<!--                              <div class="elementor-column-wrap">-->
<!--                                <div class="elementor-widget-wrap">-->
<!--                                </div>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                            <div-->
<!--                              class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-7619fdd"-->
<!--                              data-id="7619fdd" data-element_type="column">-->
<!--                              <div class="elementor-column-wrap elementor-element-populated">-->
<!--                                <div class="elementor-widget-wrap">-->
<!--                                  <div-->
<!--                                    class="elementor-element elementor-element-f13b2f5 elementor-widget elementor-widget-xs-heading"-->
<!--                                    data-id="f13b2f5" data-element_type="widget" data-widget_type="xs-heading.default">-->
<!--                                    <div class="elementor-widget-container">-->
<!--                                      <div class="xs-heading">-->
<!--                                        <h3 class="heading-sub-title">Pricing Plans</h3>-->
<!--                                        <h2 class="heading-title">OUR <span>BEST PRICING</span></h2>-->
<!--                                      </div>-->
<!--                                    </div>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                            <div-->
<!--                              class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-1995424"-->
<!--                              data-id="1995424" data-element_type="column">-->
<!--                              <div class="elementor-column-wrap">-->
<!--                                <div class="elementor-widget-wrap">-->
<!--                                </div>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div-->
<!--                        class="elementor-element elementor-element-a1655a3 elementor-widget elementor-widget-xs-price"-->
<!--                        data-id="a1655a3" data-element_type="widget" data-widget_type="xs-price.default">-->
<!--                        <div class="elementor-widget-container">-->
<!--                          <div class="xs-pricing-group">-->
<!--                            <ul class="nav nav-tabs main-nav-tab tab-swipe" role="tablist">-->
<!--                              <li>-->
<!--                                <a id="monthly-tab" class="active show" data-toggle="tab"-->
<!--                                   href="#monthly">Monthly</a>-->
<!--                              </li>-->
<!--                              <li>-->
<!--                                <a id="yearly-tab" data-toggle="tab"-->
<!--                                   href="#yearly">Yearly</a>-->
<!--                              </li>-->
<!--                            </ul>-->
<!--                            <div class="tab-content">-->
<!--                              <div class="tab-pane fadeIn animated show active" id="monthly">-->
<!--                                <div class="row">-->
<!--                                  <div class="grid col-lg-4 col-md-6">-->
<!--                                    <div class="xs-single-pricing ">-->
<!--                                      <div class="pricing-header">-->
<!--                                        <div class="pricing-img-block">-->
<!--                                          <img src="../assets/images/pricing_image.png"-->
<!--                                               alt="">-->
<!--                                        </div>-->
<!--                                        <h4 class="xs-title">Cloud Hosting</h4>-->
<!--                                      </div>&lt;!&ndash; .pricing-header END &ndash;&gt;-->

<!--                                      <div class="pricing-body">-->
<!--                                        <p>The High performance cloud platform ever</p>-->

<!--                                        <div class="pricing-price">-->
<!--                                          <p>Starting at</p>-->
<!--                                          <h2>-->
<!--                                            <sup>$</sup>49 </h2>-->

<!--                                          <h6 class="discount-price">25&#037; Discount-->
<!--                                            <del>$49.99</del>-->
<!--                                          </h6>-->
<!--                                        </div>-->
<!--                                      </div>&lt;!&ndash; .pricing-body END &ndash;&gt;-->
<!--                                      <div class="pricing-footer">-->
<!--                                        <a href="" target="_self" class="btn btn-primary">Buy Now</a>-->
<!--                                      </div>&lt;!&ndash; .pricing-footer END &ndash;&gt;-->
<!--                                    </div>&lt;!&ndash; .xs-single-pricing END &ndash;&gt;-->
<!--                                  </div>-->
<!--                                  <div class="grid col-lg-4 col-md-6">-->
<!--                                    <div class="xs-single-pricing active">-->
<!--                                      <div class="pricing-header">-->
<!--                                        <div class="pricing-img-block">-->
<!--                                          <img src="../assets/images/pricing_image.png"-->
<!--                                               alt="">-->
<!--                                        </div>-->
<!--                                        <h4 class="xs-title">VPS Hosting</h4>-->
<!--                                      </div>&lt;!&ndash; .pricing-header END &ndash;&gt;-->

<!--                                      <div class="pricing-body">-->
<!--                                        <p>The ideal solution for corporate websites and larger blogs</p>-->

<!--                                        <div class="pricing-price">-->
<!--                                          <p>Starting at</p>-->
<!--                                          <h2>-->
<!--                                            <sup>$</sup>39 </h2>-->

<!--                                          <h6 class="discount-price">25&#037; Discount-->
<!--                                            <del>$108.99</del>-->
<!--                                          </h6>-->
<!--                                        </div>-->
<!--                                      </div>&lt;!&ndash; .pricing-body END &ndash;&gt;-->
<!--                                      <div class="pricing-footer">-->
<!--                                        <a href="" target="_self" class="btn btn-primary">Buy Now</a>-->
<!--                                      </div>&lt;!&ndash; .pricing-footer END &ndash;&gt;-->
<!--                                    </div>&lt;!&ndash; .xs-single-pricing END &ndash;&gt;-->
<!--                                  </div>-->
<!--                                  <div class="grid col-lg-4 col-md-6">-->
<!--                                    <div class="xs-single-pricing ">-->
<!--                                      <div class="pricing-header">-->
<!--                                        <div class="pricing-img-block">-->
<!--                                          <img src="../assets/images/pricing_image.png"-->
<!--                                               alt="">-->
<!--                                        </div>-->
<!--                                        <h4 class="xs-title">Shared Hosting</h4>-->
<!--                                      </div>&lt;!&ndash; .pricing-header END &ndash;&gt;-->

<!--                                      <div class="pricing-body">-->
<!--                                        <p>The High performance cloud platform ever</p>-->

<!--                                        <div class="pricing-price">-->
<!--                                          <p>Starting at</p>-->
<!--                                          <h2>-->
<!--                                            <sup>$</sup>17 </h2>-->

<!--                                          <h6 class="discount-price">25&#037; Discount-->
<!--                                            <del>$29.99</del>-->
<!--                                          </h6>-->
<!--                                        </div>-->
<!--                                      </div>&lt;!&ndash; .pricing-body END &ndash;&gt;-->
<!--                                      <div class="pricing-footer">-->
<!--                                        <a href="" target="_self" class="btn btn-primary">Buy Now</a>-->
<!--                                      </div>&lt;!&ndash; .pricing-footer END &ndash;&gt;-->
<!--                                    </div>&lt;!&ndash; .xs-single-pricing END &ndash;&gt;-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                              <div class="tab-pane fadeIn animated" id="yearly">-->
<!--                                <div class="row">-->
<!--                                  <div class="grid col-lg-4 col-md-6">-->
<!--                                    <div class="xs-single-pricing ">-->
<!--                                      <div class="pricing-header">-->
<!--                                        <div class="pricing-img-block">-->
<!--                                          <img src="../assets/images/pricing_image.png"-->
<!--                                               alt="">-->
<!--                                        </div>-->
<!--                                        <h4 class="xs-title">Dedicated Server</h4>-->
<!--                                      </div>&lt;!&ndash; .pricing-header END &ndash;&gt;-->

<!--                                      <div class="pricing-body">-->
<!--                                        <p>The High performance cloud platform ever</p>-->

<!--                                        <div class="pricing-price">-->
<!--                                          <p></p>-->
<!--                                          <h2>-->
<!--                                            <sup>$</sup>29.99 </h2>-->

<!--                                          <h6 class="discount-price">25&#037; Discount-->
<!--                                            <del>$29.99</del>-->
<!--                                          </h6>-->
<!--                                        </div>-->
<!--                                      </div>&lt;!&ndash; .pricing-body END &ndash;&gt;-->
<!--                                      <div class="pricing-footer">-->
<!--                                        <a href="" target="_self" class="btn btn-primary">Buy Now</a>-->
<!--                                      </div>&lt;!&ndash; .pricing-footer END &ndash;&gt;-->
<!--                                    </div>&lt;!&ndash; .xs-single-pricing END &ndash;&gt;-->
<!--                                  </div>-->
<!--                                  <div class="grid col-lg-4 col-md-6">-->
<!--                                    <div class="xs-single-pricing active">-->
<!--                                      <div class="pricing-header">-->
<!--                                        <div class="pricing-img-block">-->
<!--                                          <img src="../assets/images/pricing_image.png"-->
<!--                                               alt="">-->
<!--                                        </div>-->
<!--                                        <h4 class="xs-title">Reseller Hosting</h4>-->
<!--                                      </div>&lt;!&ndash; .pricing-header END &ndash;&gt;-->

<!--                                      <div class="pricing-body">-->
<!--                                        <p>The High performance cloud platform ever</p>-->

<!--                                        <div class="pricing-price">-->
<!--                                          <p></p>-->
<!--                                          <h2>-->
<!--                                            <sup>$</sup>29.99 </h2>-->

<!--                                          <h6 class="discount-price">25&#037; Discount-->
<!--                                            <del>$29.99</del>-->
<!--                                          </h6>-->
<!--                                        </div>-->
<!--                                      </div>&lt;!&ndash; .pricing-body END &ndash;&gt;-->
<!--                                      <div class="pricing-footer">-->
<!--                                        <a href="" target="_self" class="btn btn-primary">Buy Now</a>-->
<!--                                      </div>&lt;!&ndash; .pricing-footer END &ndash;&gt;-->
<!--                                    </div>&lt;!&ndash; .xs-single-pricing END &ndash;&gt;-->
<!--                                  </div>-->
<!--                                  <div class="grid col-lg-4 col-md-6">-->
<!--                                    <div class="xs-single-pricing ">-->
<!--                                      <div class="pricing-header">-->
<!--                                        <div class="pricing-img-block">-->
<!--                                          <img src="../assets/images/pricing_image.png"-->
<!--                                               alt="">-->
<!--                                        </div>-->
<!--                                        <h4 class="xs-title">Shared Hosting</h4>-->
<!--                                      </div>&lt;!&ndash; .pricing-header END &ndash;&gt;-->

<!--                                      <div class="pricing-body">-->
<!--                                        <p>The High performance cloud platform ever</p>-->

<!--                                        <div class="pricing-price">-->
<!--                                          <p></p>-->
<!--                                          <h2>-->
<!--                                            <sup>$</sup>29.99 </h2>-->

<!--                                          <h6 class="discount-price">25&#037; Discount-->
<!--                                            <del>$29.99</del>-->
<!--                                          </h6>-->
<!--                                        </div>-->
<!--                                      </div>&lt;!&ndash; .pricing-body END &ndash;&gt;-->
<!--                                      <div class="pricing-footer">-->
<!--                                        <a href="" target="_self" class="btn btn-primary">Buy Now</a>-->
<!--                                      </div>&lt;!&ndash; .pricing-footer END &ndash;&gt;-->
<!--                                    </div>&lt;!&ndash; .xs-single-pricing END &ndash;&gt;-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <section-->
<!--                        class="elementor-section elementor-inner-section elementor-element elementor-element-78b5d72 elementor-section-boxed elementor-section-height-default elementor-section-height-default"-->
<!--                        data-id="78b5d72" data-element_type="section">-->
<!--                        <div class="elementor-container elementor-column-gap-default">-->
<!--                          <div class="elementor-row">-->
<!--                            <div-->
<!--                              class="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-b52aa69"-->
<!--                              data-id="b52aa69" data-element_type="column">-->
<!--                              <div class="elementor-column-wrap elementor-element-populated">-->
<!--                                <div class="elementor-widget-wrap">-->
<!--                                  <div-->
<!--                                    class="elementor-element elementor-element-a38fc51 elementor-widget elementor-widget-heading"-->
<!--                                    data-id="a38fc51" data-element_type="widget" data-widget_type="heading.default">-->
<!--                                    <div class="elementor-widget-container">-->
<!--                                      <h5 class="elementor-heading-title elementor-size-default"><a-->
<!--                                        href="https://episcloud.com/pricing/">See plan details</a> and pricing for more-->
<!--                                        information</h5></div>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </section>-->
<!--                      <div-->
<!--                        class="elementor-element elementor-element-6e48aea elementor-icon-list&#45;&#45;layout-inline elementor-align-center elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"-->
<!--                        data-id="6e48aea" data-element_type="widget" data-widget_type="icon-list.default">-->
<!--                        <div class="elementor-widget-container">-->
<!--                          <ul class="elementor-icon-list-items elementor-inline-items">-->
<!--                            <li class="elementor-icon-list-item elementor-inline-item">-->
<!--                              <span class="elementor-icon-list-icon">-->
<!--                                    <i class="icon icon-back_up" aria-hidden="true"></i>-->
<!--                              </span>-->
<!--                              <span class="elementor-icon-list-text">Daily backups</span>-->
<!--                            </li>-->
<!--                            <li class="elementor-icon-list-item elementor-inline-item">-->
<!--                              <span class="elementor-icon-list-icon">-->
<!--                                        <i class="icon icon-migration" aria-hidden="true"></i>-->
<!--                              </span>-->
<!--                              <span class="elementor-icon-list-text">Free migrations</span>-->
<!--                            </li>-->
<!--                            <li class="elementor-icon-list-item elementor-inline-item">-->
<!--                              <span class="elementor-icon-list-icon">-->
<!--                                        <i class="icon icon-checkmark" aria-hidden="true"></i>-->
<!--                              </span>-->
<!--                              <span class="elementor-icon-list-text">Staging environments</span>-->
<!--                            </li>-->
<!--                          </ul>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div
            class="elementor-section elementor-top-section elementor-element elementor-element-1241fee overflow-hidden elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="1241fee" data-element_type="section">
            <div class="elementor-container elementor-column-gap-default">
              <div class="elementor-row">
                <div
                  class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6b010a6"
                  data-id="6b010a6" data-element_type="column">
                  <div class="elementor-column-wrap elementor-element-populated">
                    <div class="elementor-widget-wrap">
                      <div
                        class="elementor-element elementor-element-34c5e5b elementor-widget elementor-widget-xs-heading"
                        data-id="34c5e5b" data-element_type="widget" data-widget_type="xs-heading.default">
                        <div class="elementor-widget-container">
                          <div class="xs-heading">
                            <h3 class="heading-sub-title">Best Service</h3>
                            <h2 class="heading-title">OUR <span>BEST SERVICE</span></h2>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-section elementor-inner-section elementor-element elementor-element-45be439 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="45be439" data-element_type="section">
                        <div class="elementor-container elementor-column-gap-default">
                          <div class="elementor-row">
                            <div
                              class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-cf1f22a animated-slow elementor-invisible"
                              data-id="cf1f22a" data-element_type="column"
                              data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:0.7}">
                              <div class="elementor-column-wrap elementor-element-populated">
                                <div class="elementor-widget-wrap">
                                  <div
                                    class="elementor-element elementor-element-d6c9161 elementor-widget elementor-widget-xs-service-box"
                                    data-id="d6c9161" data-element_type="widget"
                                    data-widget_type="xs-service-box.default">
                                    <div class="elementor-widget-container">

                                      <div class="xs-service-block">
                                        <div class="service-img">
                                          <img width="96" height="96"
                                               src="../assets/images/service-7.png"
                                               class="attachment-full size-full" alt=""/></div>
                                        <h4 class="xs-title"><a href="#">Shared Hosting</a></h4>
                                        
                                        <a href="https://dash.episcloud.com/" class="simple-btn icon-right">Learn More<i
                                          class="icon icon-play2"></i></a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-9ef736d animated-slow elementor-invisible"
                              data-id="9ef736d" data-element_type="column"
                              data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:1.5}">
                              <div class="elementor-column-wrap elementor-element-populated">
                                <div class="elementor-widget-wrap">
                                  <div
                                    class="elementor-element elementor-element-ad3ae89 elementor-widget elementor-widget-xs-service-box"
                                    data-id="ad3ae89" data-element_type="widget"
                                    data-widget_type="xs-service-box.default">
                                    <div class="elementor-widget-container">

                                      <div class="xs-service-block">
                                        <div class="service-img">
                                          <img width="96" height="96"
                                               src="../assets/images/service-8.png"
                                               class="attachment-full size-full" alt="" /></div>
                                        <h4 class="xs-title"><a href="#">Reseller Hosting</a></h4>
                                       
                                        <a href="https://dash.episcloud.com/" class="simple-btn icon-right">Learn More<i
                                          class="icon icon-play2"></i></a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-e9ad084 animated-slow elementor-invisible"
                              data-id="e9ad084" data-element_type="column"
                              data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;,&quot;animation_delay&quot;:2}">
                              <div class="elementor-column-wrap elementor-element-populated">
                                <div class="elementor-widget-wrap">
                                  <div
                                    class="elementor-element elementor-element-af488d3 elementor-widget elementor-widget-xs-service-box"
                                    data-id="af488d3" data-element_type="widget"
                                    data-widget_type="xs-service-box.default">
                                    <div class="elementor-widget-container">

                                      <div class="xs-service-block">
                                        <div class="service-img">
                                          <img width="96" height="96"
                                               src="../assets/images/service-9.png"
                                               class="attachment-full size-full" alt=""/></div>
                                        <h4 class="xs-title"><a href="#">VPS Hosting</a></h4>
                                       
                                        <a href="https://dash.episcloud.com/" class="simple-btn icon-right">Learn More<i
                                          class="icon icon-play2"></i></a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-section elementor-inner-section elementor-element elementor-element-4023c1e overflow-hidden elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="4023c1e" data-element_type="section">
                        <div class="elementor-container elementor-column-gap-default">
                          <div class="elementor-row">
                            <div
                              class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-37dd3cb animated-slow elementor-invisible"
                              data-id="37dd3cb" data-element_type="column"
                              data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;}">
                              <div class="elementor-column-wrap elementor-element-populated">
                                <div class="elementor-widget-wrap">
                                  <div
                                    class="elementor-element elementor-element-ef62abe elementor-widget elementor-widget-xs-service-box"
                                    data-id="ef62abe" data-element_type="widget"
                                    data-widget_type="xs-service-box.default">
                                    <div class="elementor-widget-container">

                                      <div class="xs-service-block">
                                        <div class="service-img">
                                          <img width="96" height="96"
                                               src="../assets/images/service-10.png"
                                               class="attachment-full size-full" alt=""/></div>
                                        <h4 class="xs-title"><a href="#">Cloud Hosting</a></h4>
                                        
                                        <a href="https://dash.episcloud.com/" class="simple-btn icon-right">Learn More<i
                                          class="icon icon-play2"></i></a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-77e7397 animated-slow elementor-invisible"
                              data-id="77e7397" data-element_type="column"
                              data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;}">
                              <div class="elementor-column-wrap elementor-element-populated">
                                <div class="elementor-widget-wrap">
                                  <div
                                    class="elementor-element elementor-element-460faaa elementor-widget elementor-widget-xs-service-box"
                                    data-id="460faaa" data-element_type="widget"
                                    data-widget_type="xs-service-box.default">
                                    <div class="elementor-widget-container">

                                      <div class="xs-service-block">
                                        <div class="service-img">
                                          <img width="96" height="96"
                                               src="../assets/images/service-11.png"
                                               class="attachment-full size-full" alt=""/></div>
                                        <h4 class="xs-title"><a href="#">Dedicated Hosting</a></h4>
                                        
                                        <a href="https://dash.episcloud.com/" class="simple-btn icon-right">Learn More<i
                                          class="icon icon-play2"></i></a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-103e5c6 animated-slow elementor-invisible"
                              data-id="103e5c6" data-element_type="column"
                              data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;}">
                              <div class="elementor-column-wrap elementor-element-populated">
                                <div class="elementor-widget-wrap">
                                  <div
                                    class="elementor-element elementor-element-02bc2d8 elementor-widget elementor-widget-xs-service-box"
                                    data-id="02bc2d8" data-element_type="widget"
                                    data-widget_type="xs-service-box.default">
                                    <div class="elementor-widget-container">

                                      <div class="xs-service-block">
                                        <div class="service-img">
                                          <img width="96" height="96"
                                               src="../assets/images/service-12.png"
                                               class="attachment-full size-full" alt=""/></div>
                                        <h4 class="xs-title"><a href="#">Domain Name</a></h4>
                                        
                                        <a href="https://dash.episcloud.com/" class="simple-btn icon-right">Learn More<i
                                          class="icon icon-play2"></i></a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-section elementor-top-section elementor-element elementor-element-6292b25 overflow-hidden elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="6292b25" data-element_type="section"
            data-settings="{&quot;background_background&quot;:&quot;gradient&quot;}">
            <div class="elementor-background-overlay"></div>
            <div class="elementor-container elementor-column-gap-default">
              <div class="elementor-row">
                <div
                  class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-b2bef71"
                  data-id="b2bef71" data-element_type="column"
                  data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                  <div class="elementor-column-wrap elementor-element-populated">
                    <div class="elementor-widget-wrap">
                      <section
                        class="elementor-section elementor-inner-section elementor-element elementor-element-441f5ec elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="441f5ec" data-element_type="section"
                        data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                        <div class="elementor-background-overlay"></div>
                        <div class="elementor-container elementor-column-gap-default">
                          <div class="elementor-row">
                            <div
                              class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-b2310a8"
                              data-id="b2310a8" data-element_type="column">
                              <div class="elementor-column-wrap">
                                <div class="elementor-widget-wrap">
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-881748b"
                              data-id="881748b" data-element_type="column">
                              <div class="elementor-column-wrap elementor-element-populated">
                                <div class="elementor-widget-wrap">
                                  <div
                                    class="elementor-element elementor-element-6e18464 elementor-widget elementor-widget-heading"
                                    data-id="6e18464" data-element_type="widget" data-widget_type="heading.default">
                                    <div class="elementor-widget-container">
                                      <h2 class="elementor-heading-title elementor-size-default">We don’t compromise
                                        with
                                        the best Hosting Solution</h2></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-9936c49"
                              data-id="9936c49" data-element_type="column">
                              <div class="elementor-column-wrap">
                                <div class="elementor-widget-wrap">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-section elementor-top-section elementor-element elementor-element-20eb49d elementor-section-content-top overflow-hidden elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="20eb49d" data-element_type="section">
            <div class="elementor-container elementor-column-gap-default">
              <div class="elementor-row">
                <div
                  class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-cae3056 animated-slow elementor-invisible"
                  data-id="cae3056" data-element_type="column"
                  data-settings="{&quot;animation&quot;:&quot;fadeInLeft&quot;}">
                  <div class="elementor-column-wrap elementor-element-populated">
                    <div class="elementor-widget-wrap">
                      <div
                        class="elementor-element elementor-element-d1299d0 elementor-widget elementor-widget-xs-call-to-action-box"
                        data-id="d1299d0" data-element_type="widget" data-widget_type="xs-call-to-action-box.default">
                        <div class="elementor-widget-container">
                          <div class="xs-feature-group">
                            <div class="media">
                              <div class="feature-img d-flex">
                                <img width="132" height="149"
                                     src="../assets/images/sheild.png"
                                     class="attachment-full size-full" alt="" /></div>
                              <div class="media-body feature-content">
                                <h4 class="xs-title">Days money back guarantee</h4>
                                <p>30 Days Trial Can Cancel Anytime And Get Your Money Back.</p>
                                <div class="xs-btn-wraper">
                                  <a href="#" class="btn btn-secondary">Know More</a>
                                </div>
                              </div>
                            </div>
                            <span class="icon icon-dollar watermark-icon"></span>
                          </div><!-- .xs-feature-group END -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-a3396ca animated-slow elementor-invisible"
                  data-id="a3396ca" data-element_type="column"
                  data-settings="{&quot;animation&quot;:&quot;fadeInRight&quot;}">
                  <div class="elementor-column-wrap elementor-element-populated">
                    <div class="elementor-widget-wrap">
                      <div
                        class="elementor-element elementor-element-96fe986 elementor-widget elementor-widget-xs-call-to-action-box"
                        data-id="96fe986" data-element_type="widget" data-widget_type="xs-call-to-action-box.default">
                        <div class="elementor-widget-container">
                          <div class="xs-feature-group">
                            <div class="media">
                              <div class="feature-img d-flex">
                                <img width="124" height="104"
                                     src="../assets/images/cloud-lock.png"
                                     class="attachment-full size-full" alt="" /></div>
                              <div class="media-body feature-content">
                                <h4 class="xs-title">Build and protect your brand</h4>
                                <p>Share processes an data secure lona need to know basis without the need.</p>
                                <div class="xs-btn-wraper">
                                  <a href="#" class="btn btn-secondary">Know More</a>
                                </div>
                              </div>
                            </div>
                            <span class="icon icon-dollar watermark-icon"></span>
                          </div><!-- .xs-feature-group END -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-section elementor-top-section elementor-element elementor-element-2baafa8 overflow-hidden elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="2baafa8" data-element_type="section">
            <div class="elementor-container elementor-column-gap-default">
              <div class="elementor-row">
                <div
                  class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-aac6785"
                  data-id="aac6785" data-element_type="column">
                  <div class="elementor-column-wrap elementor-element-populated">
                    <div class="elementor-widget-wrap">
                      <div
                        class="elementor-element elementor-element-43ea13d elementor-widget elementor-widget-xs-partner"
                        data-id="43ea13d" data-element_type="widget" data-widget_type="xs-partner.default">
                        <div class="elementor-widget-container">
                          <div class="xs-client-slider owl-carousel">
                            <div class="single-client">
                              <a href="#" target="_self"> <img
                                src="../assets/images/client-1.png" alt="client-1"></a>
                            </div>
                            <div class="single-client">
                              <a href="#" target="_self"> <img
                                src="../assets/images/client-2.png" alt="client-2"></a>
                            </div>
                            <div class="single-client">
                              <a href="#" target="_self"> <img
                                src="../assets/images/client-3.png" alt="client-3"></a>
                            </div>
                            <div class="single-client">
                              <a href="#" target="_self"> <img
                                src="../assets/images/client-4.png" alt="client-4"></a>
                            </div>
                            <div class="single-client">
                              <a href="#" target="_self"> <img
                                src="../assets/images/client-5.png" alt="client-5"></a>
                            </div>
                            <div class="single-client">
                              <a href="" target="_self"> <img
                                src="../assets/images/logoCabra-22922f11824ab41d2939a9d7a87c9ba9-2.svg"
                                alt="logoCabra-22922f11824ab41d2939a9d7a87c9ba9 (2)"></a>
                            </div>
                            <div class="single-client">
                              <a href="" target="_self"> <img
                                src="../assets/images/download-4.png"
                                alt="download (4)"></a>
                            </div>
                            <div class="single-client">
                              <a href="" target="_self"> <img
                                src="../assets/images/epis.png" alt="epis"></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-section elementor-top-section elementor-element elementor-element-d94cefe elementor-section-content-middle overflow-hidden elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="d94cefe" data-element_type="section">
            <div class="elementor-container elementor-column-gap-default">
              <div class="elementor-row">
                <div
                  class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-5d8188b"
                  data-id="5d8188b" data-element_type="column">
                  <div class="elementor-column-wrap elementor-element-populated">
                    <div class="elementor-widget-wrap">
                      <div
                        class="elementor-element elementor-element-0a62712 elementor-widget elementor-widget-xs-animated-image-box"
                        data-id="0a62712" data-element_type="widget" data-widget_type="xs-animated-image-box.default">
                        <div class="elementor-widget-container">
                          <div class="hosting-info-img">
                            <img src="../assets/images/info-img-1.png"
                                 alt="info-img-1">

                            <img src="../assets/images/icon-1.png"
                                 class="info-icon icon-1"
                                 alt="icon-1">

                            <img src="../assets/images/icon-2.png"
                                 class="info-icon icon-2"
                                 alt="icon-2">

                            <img src="../assets/images/icon-3.png"
                                 class="info-icon icon-3"
                                 alt="icon-3">

                            <img src="../assets/images/icon-4.png"
                                 class="info-icon icon-4"
                                 alt="icon-4">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-693dfe6"
                  data-id="693dfe6" data-element_type="column">
                  <div class="elementor-column-wrap elementor-element-populated">
                    <div class="elementor-widget-wrap">
                      <div
                        class="elementor-element elementor-element-1b5f974 elementor-widget elementor-widget-xs-spinner-icon"
                        data-id="1b5f974" data-element_type="widget" data-widget_type="xs-spinner-icon.default">
                        <div class="elementor-widget-container">
                          <div class="spinner-icon wow">
                            <img width="65" height="65"
                                 src="../assets/images/electric-wave.png"
                                 class="attachment-full size-full" alt="" /></div>

                        </div>
                      </div>
                      <div
                        class="elementor-element elementor-element-fa77372 animated-slow elementor-invisible elementor-widget elementor-widget-heading"
                        data-id="fa77372" data-element_type="widget"
                        data-settings="{&quot;_animation&quot;:&quot;fadeInUp&quot;}"
                        data-widget_type="heading.default">
                        <div class="elementor-widget-container">
                          <h2 class="elementor-heading-title elementor-size-default">Get best plans for more Power</h2>
                        </div>
                      </div>
                      <div
                        class="elementor-element elementor-element-c31e4d7 animated-slow elementor-invisible elementor-widget elementor-widget-text-editor"
                        data-id="c31e4d7" data-element_type="widget"
                        data-settings="{&quot;_animation&quot;:&quot;fadeInUp&quot;}"
                        data-widget_type="text-editor.default">
                        <div class="elementor-widget-container">
                          <div class="elementor-text-editor elementor-clearfix">
                            Our best-in-class WordPress solution, with additional optimization to make running a
                            WooCommerce online store easy. Our prices are clear and straight forward so you can
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-element elementor-element-215646f animated-slow elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-invisible elementor-widget elementor-widget-icon-list"
                        data-id="215646f" data-element_type="widget"
                        data-settings="{&quot;_animation&quot;:&quot;fadeInUp&quot;}"
                        data-widget_type="icon-list.default">
                        <div class="elementor-widget-container">
                          <ul class="elementor-icon-list-items">
                            <li class="elementor-icon-list-item">
                              <span class="elementor-icon-list-icon">
                                        <i class="fa fa-check" aria-hidden="true"></i>
                              </span>
                              <span
                                class="elementor-icon-list-text">We've been supporting WordPress since the beginning.</span>
                            </li>
                            <li class="elementor-icon-list-item">
                             <span class="elementor-icon-list-icon">
                                      <i class="fa fa-check" aria-hidden="true"></i>
                              </span>
                              <span class="elementor-icon-list-text">Perfect for large sites or agencies managing multiple clients.</span>
                            </li>
                            <li class="elementor-icon-list-item">
                              <span class="elementor-icon-list-icon">
                                        <i class="fa fa-check" aria-hidden="true"></i>
                              </span>
                              <span
                                class="elementor-icon-list-text">Our easy-to-use control panel and API let you spend</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div
                        class="elementor-element elementor-element-2dc2485 elementor-tablet-align-center animated-slow elementor-invisible elementor-widget elementor-widget-xs-button"
                        data-id="2dc2485" data-element_type="widget"
                        data-settings="{&quot;_animation&quot;:&quot;fadeInUp&quot;}"
                        data-widget_type="xs-button.default">
                        <div class="elementor-widget-container">
                          <a href="#" target="_self" class="xs-btn btn btn-primary">
                            <span class="xs-button-icon xs-align-icon-left"><i class="" aria-hidden="true"></i></span>
                            <span class="xs-button-text">Get Started</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-section elementor-top-section elementor-element elementor-element-4ff6f4a elementor-section-content-middle overflow-hidden elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="4ff6f4a" data-element_type="section">
            <div class="elementor-container elementor-column-gap-default">
              <div class="elementor-row">
                <div
                  class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-5bf41db elementor-invisible"
                  data-id="5bf41db" data-element_type="column"
                  data-settings="{&quot;animation&quot;:&quot;fadeInLeft&quot;}">
                  <div class="elementor-column-wrap elementor-element-populated">
                    <div class="elementor-widget-wrap">
                      <div class="elementor-element elementor-element-142464b elementor-widget elementor-widget-heading"
                           data-id="142464b" data-element_type="widget" data-widget_type="heading.default">
                        <div class="elementor-widget-container">
                          <h2 class="elementor-heading-title elementor-size-default">Powerful Server and Platform</h2>
                        </div>
                      </div>
                      <div
                        class="elementor-element elementor-element-15767ab elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                        data-id="15767ab" data-element_type="widget" data-widget_type="image-box.default">
                        <div class="elementor-widget-container">
                          <div class="elementor-image-box-wrapper">
                            <figure class="elementor-image-box-img"><img width="43" height="38"
                                                                         src="../assets/images/gaurd-icon.png"
                                                                         class="attachment-full size-full" alt=""
                                                                         /></figure>
                            <div class="elementor-image-box-content"><h3 class="elementor-image-box-title"> High safety and security</h3>
                              <p class="elementor-image-box-description"></p></div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-element elementor-element-9c467b9 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                        data-id="9c467b9" data-element_type="widget" data-widget_type="image-box.default">
                        <div class="elementor-widget-container">
                          <div class="elementor-image-box-wrapper">
                            <figure class="elementor-image-box-img"><img width="46" height="44"
                                                                         src="../assets/images/cloud-icon.png"
                                                                         class="attachment-full size-full" alt=""
                                                                         /></figure>
                            <div class="elementor-image-box-content"><h3 class="elementor-image-box-title"> Better
                              Security and faster Server</h3>
                              <p class="elementor-image-box-description"></p></div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-element elementor-element-a48bdd1 elementor-position-left elementor-vertical-align-top elementor-widget elementor-widget-image-box"
                        data-id="a48bdd1" data-element_type="widget" data-widget_type="image-box.default">
                        <div class="elementor-widget-container">
                          <div class="elementor-image-box-wrapper">
                            <figure class="elementor-image-box-img"><img width="33" height="30"
                                                                         src="../assets/images/clock-icon.png"
                                                                         class="attachment-full size-full" alt=""
                                                                         /></figure>
                            <div class="elementor-image-box-content"><h3 class="elementor-image-box-title"> Share processes and data secure lona need to know basis
</h3>
                              <p class="elementor-image-box-description"></p></div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="elementor-element elementor-element-07ccc37 elementor-tablet-align-center elementor-widget elementor-widget-xs-button"
                        data-id="07ccc37" data-element_type="widget" data-widget_type="xs-button.default">
                        <div class="elementor-widget-container">
                          <a href="https://dash.episcloud.com" target="_self" class="xs-btn btn btn-primary">
                            <span class="xs-button-icon xs-align-icon-left"><i class="" aria-hidden="true"></i></span>
                            <span class="xs-button-text">Get Started</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-027e85d animated-slow elementor-invisible"
                  data-id="027e85d" data-element_type="column"
                  data-settings="{&quot;animation&quot;:&quot;fadeInRight&quot;}">
                  <div class="elementor-column-wrap elementor-element-populated">
                    <div class="elementor-widget-wrap">
                      <div class="elementor-element elementor-element-a6a6326 elementor-widget elementor-widget-image"
                           data-id="a6a6326" data-element_type="widget" data-widget_type="image.default">
                        <div class="elementor-widget-container">
                          <div class="elementor-image">
                            <img width="591" height="631"
                                 src="../assets/images/info-img-2.png"
                                 class="attachment-large size-large" alt=""
                                 srcset="../assets/images/info-img-2.png 591w, ../assets/images/info-img-2-281x300.png 281w"
                                 sizes="(max-width: 591px) 100vw, 591px"/></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue